module.exports = __webpack_public_path__ + "29410d15f7991a9f06e79713cb0cdebd.png";